
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {FileUploadNG } from './file-upload-ng';
import * as util from "./util";
import './board.css';
import {Header} from './header.js';
import {Footer} from './footer.js';
let faqForum = [];

export class Board extends Component {
  constructor(props) {
    super(props);
    this.createUUID = this.createUUID.bind(this);
    this.getPosts = this.getPosts.bind(this);
    this.unflatten = this.unflatten.bind(this);
    this.newPost = this.newPost.bind(this);
    this.deletePost = this.deletePost.bind(this);
    this.onSave = this.onSave.bind(this);
    this.thread = this.thread.bind(this);
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.state = ({posts: [],
                   tree: [],
                   globalExpanded: null,
                   filter: ''
    });
  }

  componentWillMount() {
    this.getPosts();
  }

  createUUID() { //taken from StackOverflow
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random()*16|0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
    return uuid;
  }

  getPosts(filter='') {
    const self = this;
    const url = `/api/get-posts?uuid=${this.props.match.params.uuid}&filter=${filter}`;
    const headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        alert('Forenbeiträge konnten nicht geladen werden.');
        console.error('Could not load board posts.', exception);
      });

    promise.then(function (json) {
      self.setState({posts: json,
                     tree: self.unflatten(json)
      });
    })
  }

  newPost(pid, title) {
    if(JSON.parse(localStorage.getItem('user')).username !== 'guest') {
      if(pid === undefined) {
        pid = 0;
      }
      var posts = this.state.posts.slice();
      var id = this.createUUID();
      var user = JSON.parse(localStorage.getItem('user')).username;
      posts.unshift({id: id, key: id, pid: pid, message: '', title: title !== undefined ? title : '', expanded: true, saved: true, file: '', active: true, user: user});
      this.setState({posts: posts,
                     tree: this.unflatten(posts)
      });
    }
  }

  deletePost(id) {
    var self = this;
    const url='/api/delete-post';
    var headers = util.defaultHeaders();
    var body = `id=${id}`;
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: body
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte den Beitrag nicht löschen.');
        console.error('Could not delete this post.', exception);
      })
    promise.then(function(json) {
      self.setState({posts: [],
                     tree: []
      }, self.getPosts());
    });
  }

  onSave() {
    this.getPosts();
  }

  unflatten(postList, parent = {id: 0}, tree = []) {
    var children = postList.filter( post => post.pid === parent.id);
    if(children.length > 0) {
      if(parent.id === 0) {
        tree = children;
      } else {
        parent['children'] = children;
      }
      children.map(child => this.unflatten(postList, child));
    }
    return tree;
  }

  thread(node, boardUUID, newPost, deletePost) {
    return(
      <Post id={node.id} key={node.id} pid={node.pid} title={node.title} message={node.message} boardUUID={boardUUID} user={node.user}
            file={node.file} active={node.active} owner_name={node.owner_name} owner_role={node.owner_role}
            children={node.children !== undefined ? node.children.map(child => this.thread(child, boardUUID, newPost, deletePost)) : null}
            newPost={newPost} deletePost={deletePost} expanded={this.state.globalExpanded !== null ? this.state.globalExpanded : node.expanded} saved={node.saved} onSave={this.onSave} />
    )
  }

  expandAll() {
    if(window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Wirklich alles aufklappen?")) {
      this.setState({globalExpanded: true, posts: [], tree: []}, this.getPosts());
    }
  }

  collapseAll() {
    if(window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Wirklich alles zuklappen?")) {
      this.setState({globalExpanded: false, posts: [], tree: []}, this.getPosts());
    }
  }

  render() {
    return(
       <div className="Landing">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
      <div className="Board" id="mobileBoard">
        <div className="productHeader1">Produktforum zu: {localStorage.getItem('product-name')}</div>
      
       <div className="marginTop50">
        <div className="button margin-right" onClick={event => window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Möchten Sie wirklich zurück?") ? this.props.history.goBack() : false}>↰ zurück</div>
        <div className="button margin-right" onClick={this.expandAll}>alles aufklappen</div>
        <div className="button margin-right" onClick={this.collapseAll}>alles zuklappen</div>
        <span style={{fontSize: 'xx-small'}}>
          <input className="BoardSearchInput margin-right" type="text" placeholder="(Suchfilter - ein Teilwort)" onChange={event => this.setState({filter: event.target.value}, this.getPosts(event.target.value))} ></input>
        </span>
        {util.isGuestUser() === true && <h5 className="guestTitel">(für Gäste nur lesender Zugriff)</h5>}
        <div className="button" onClick={event => this.newPost()} ><b>ein neues Thema erstellen</b></div>
        </div>
       
        <div className="marginTop50">
         {this.state.tree.map(node => this.thread(node, this.props.match.params.uuid, this.newPost, this.deletePost))}
        </div>
      </div>
      </div>
      </div>
      <Footer faqs={faqForum} />
      </div>
    )
  }
}

export class Post extends Component {
  constructor(props) {
    super(props);
    this.savePost = this.savePost.bind(this);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeMessage = this.onChangeMessage.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.getFileInfo = this.getFileInfo.bind(this);
    this.state={expanded: this.props.expanded,
                saved: this.props.saved === false ? false : true,
                title: this.props.title !== undefined ? this.props.title : '',
                message: this.props.message !== undefined ? this.props.message : '',
                user: this.props.user,
                owner_name: this.props.owner_name,
                owner_role: this.props.owner_role,
                file: this.props.file !== undefined ? this.props.file : '',
                filename: (this.props.file !== undefined && this.props.file !== '') ? this.getFileInfo(this.props.file) : ''
    }
  }

  componentWillMount() {
    this.getFileInfo(this.state.file);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.file !== this.state.file) {
      this.getFileInfo(nextProps.file);
    }
  }

  savePost(id,pid,message,title,board,user,file) {
    var self = this;
    const url='/api/upsert-post';
    var headers = util.defaultHeaders();
    var body = `id=${id}&pid=${pid}&message=${message}&title=${title}&board=${board}&user=${user}&file=${file}`;
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: body
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte den Beitrag nicht speichern.');
        console.error('Could not save this post.', exception);
      })
    promise.then(json => self.setState({saved: true, expanded: false}, this.props.onSave()));
    window.scrollTo(0,0);    
  }

  onChangeTitle(newTitle) {
    this.setState({saved: false,
                   title: newTitle});
    return true;
  }

  onChangeMessage(newMessage) {
    this.setState({saved: false,
                   message: newMessage});
    return true;
  }

  onUpload(uuid, _, filename) {
    this.setState({file: uuid,
                   filename: filename,
                   saved: false},
    );
  }

  getFileInfo(uuid) {
    if(uuid !== undefined && uuid !== null && uuid !== '') {
      var self = this;
      fetch(`/api/get-file-infos?uuids=${uuid}`, {
        headers: util.defaultHeaders()
      }).then(resp => resp.json())
        .catch(error => console.log("Could not get file infos. ", error))
        .then(json => self.setState({filename: json[0].fileName}));
    }
    return true;
  }

  render() {
    return(
      <div className="Post" style={this.props.pid === 0 ? {marginTop: '50px'} : null} >
        <div style={this.state.saved ? {borderLeft: 'solid 5px', borderColor: '#1F6A81', backgroundColor:'rgba(255,255,255,0.7)'} : {borderLeft: 'solid 5px', borderColor: '#e50000', backgroundColor:'rgba(255,255,255,0.7)'}}>
          <div style={this.state.saved ? {border: 'solid 1px #1F6A81'} : {border: 'solid 1px #e50000'}} >
            <div style={{backgroundColor: 'rgba(255,255,255,0.7)', fontWeight: 'bold', padding: '2%', position: 'relative'}}>
              {this.state.expanded ? <PostTitle user={this.state.user} onChange={this.onChangeTitle} value={this.state.title} /> : <span onClick={event => this.setState({expanded: !this.state.expanded && this.props.active === true})} style={{cursor: 'pointer', color: '#1F6A81'}}>{this.state.title}</span>}
              <span style={{marginLeft: '2%', cursor: 'pointer', fontSize:'large',color:'#1F6A81'}} title={this.state.expanded === true ? 'zuklappen' : 'aufklappen'} onClick={event => this.setState({expanded: !this.state.expanded && this.props.active === true})}>{this.state.expanded === true ? '↑' : '↓'}</span>
              <span  onClick={event => this.setState({expanded: !this.state.expanded && this.props.active === true})} style={{cursor: 'pointer', marginLeft: '40px'}}>{this.state.message.substr(0,30)+'...'}</span>
              <span id="postUserNameMobile" onClick={event => this.setState({expanded: !this.state.expanded && this.props.active === true})} style={{cursor: 'pointer', position: 'absolute', color: '#1F6A81', right: '10px'}}>{(this.state.user === this.state.owner_name && this.state.owner_role === 'none-commercial') ? 'Anbieter' : this.state.user}</span>
            </div>
            {this.state.expanded === true ? <div style={{backgroundColor: 'rgba(255, 255, 255, 0.3)', padding: '10px'}}>
              <PostMessage user={this.state.user} onChange={this.onChangeMessage} value={this.state.message} />
            </div> : null}
            {this.state.expanded ?
             <span className="margin-left">
               <div className="button margin-right" style={!this.state.saved ? {color: 'lightgrey'} : {color: '#1F6A81'}} onClick={event => this.state.saved && this.props.newPost(this.props.id, this.props.title)}>antworten</div>
               <div className="button margin-right" style={this.state.saved ? {color: 'lightgrey'} : {color: '#1F6A81'}} onClick={event => !this.state.saved && this.savePost(this.props.id, this.props.pid, this.state.message, this.state.title,this.props.boardUUID,JSON.parse(localStorage.getItem('user')).username,this.state.file)}>speichern</div>
               {JSON.parse(localStorage.getItem('user')).username === this.state.user ? <div className="button" onClick={event => window.confirm("Wirklich löschen?") ? this.props.deletePost(this.props.id) : false}>löschen</div> : null}
               {this.state.file === '' && JSON.parse(localStorage.getItem('user')).username === this.state.user ?
                <div className="BoardFieUpload margin-left">
                  <FileUploadNG onFinish={this.onUpload} />
                </div>:

                <div className="PostAttachment marginTop2 margin-left">
                  <span>Dateianhang: {this.state.filename}</span>
                  { JSON.parse(localStorage.getItem('user')).username === this.state.user ? <span style={{color: '#e50000', cursor: 'pointer',fontSize:'medium'}} onClick={ () => this.setState({file: '', saved: false})}> ✗ </span>: null}<span><Link style={{color:'#1F6A81', fontSize:'large', textDecoration:'none'}} to={`/${this.state.file}/${this.state.filename}`} target="_blank"> ↓ </Link></span>
                </div>
               }
             </span> :
             null
            }
          </div>
        </div>
        {this.props.children}
      </div>
    )
  }
}

class PostTitle extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: (this.props.value !== undefined ? this.props.value : ''),
                maxLength: this.props.maxLength ? this.props.maxLength : 100};
  }

  onChange(event) {
    if(this.props.user === JSON.parse(localStorage.getItem('user')).username && event.target.value.length <= this.state.maxLength) {
      this.props.onChange(event.target.value);
      this.setState({value: event.target.value});
    }
    return true;
  }

  render() {
    return (
      <div className="PostTitle">
        <input className="PostTitleInput"type="text" placeholder='' value={this.state.value} onChange={this.onChange} />
      </div>
    )
  }
}

class PostMessage extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state={value: (this.props.value !== undefined ? this.props.value : ''),
                maxLength: this.props.maxLength ? this.props.maxLength : 3000};
  }

  onChange(event) {
    if(this.props.user === JSON.parse(localStorage.getItem('user')).username && event.target.value.length <= this.state.maxLength) {
      this.props.onChange(event.target.value);
      this.setState({value: event.target.value});
    }
    return true;
  }

  render() {
    return (
      <div className="PostMessage">
        <textarea className="PostMessage" placeholder="" value={this.state.value} onChange={this.onChange} rows='6' cols='100' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/board.js